import * as React from 'react';
export const linkSvg = React.forwardRef(function linkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.707 7.091a2.685 2.685 0 0 0-3.798-3.798L7.763 4.44a.753.753 0 1 1-1.066-1.066l1.147-1.146a4.192 4.192 0 0 1 5.928 5.928l-1.146 1.147a.753.753 0 0 1-1.066-1.066l1.147-1.146Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.26 10.76a.753.753 0 0 1 0-1.066l4.434-4.435a.753.753 0 0 1 1.065 1.065L6.325 10.76a.753.753 0 0 1-1.066 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.293 12.707a2.685 2.685 0 0 1 0-3.798L4.44 7.763a.753.753 0 1 0-1.066-1.066L2.228 7.844a4.192 4.192 0 0 0 5.928 5.928l1.147-1.146a.753.753 0 0 0-1.066-1.066l-1.146 1.147a2.685 2.685 0 0 1-3.798 0Z',
    }),
  );
});
linkSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var link = {
  category: 'icon',
  colorable: true,
  name: 'link',
  svg: linkSvg,
};
